<template>
  <component
    :is="referenceComponent"
    v-if="referenceComponent"
    :value="referenceValue"
    :formValue="combinedFormValue"
    disabled
    :editable="false"
    v-bind="$props"
  />
  <div v-else>{{ referenceValue }}</div>
</template>

<script>
import _get from 'lodash/get'
import { inject } from '@vue/composition-api'
import matchInputTypes from '@/components/Forms/matchInputTypes'
import FormMixin from '@/components/Forms/FormMixin'
import { ReferenceValueSources } from '@shared/sm/general/sectionTemplate/subdomains/questions/types'
import useSyllabusReferenceValues from '@sy/client/exposed/referenceValues/useReferenceValues'
import { ReferenceValueSources as SyllabusReferenceValueSources } from '@sy/client/exposed/referenceValues/referenceValueSources'

export default {
  mixins: [ FormMixin ],
  props: {
    question: {
      type: Object,
      required: true,
    },
    formValue: {
      type: Object,
      required: false,
    },
  },
  setup () {
    const course = inject('course', {})
    const term = inject('term', {})
    const partOfTerm = inject('partOfTerm', {})

    const { injectReferences: injectSyllabusReferences } = useSyllabusReferenceValues()
    const { cmCourse, section } = injectSyllabusReferences()

    return { course, term, partOfTerm, cmCourse, section }
  },
  computed: {
    referenceValueConfig () {
      return this.question.config?.referenceValue || {}
    },
    referenceSourceObject () {
      const referenceSource = this.referenceValueConfig?.referenceSource
      switch (referenceSource) {
        case ReferenceValueSources.SmCourse:
          return this.course
        case ReferenceValueSources.Term:
          return this.term
        case ReferenceValueSources.PartOfTerm:
          return this.partOfTerm
        case SyllabusReferenceValueSources.CmCourse:
          return this.cmCourse
        case SyllabusReferenceValueSources.Section:
          return this.section
        default:
          return {}
      }
    },
    referenceValue () {
      // We allow accessing nested fields (e.g 'credits.creditHours.min'),
      // so we MUST use _get here and this should NOT be changed to dot notation.
      return _get(this.referenceSourceObject, this.referenceValueConfig.referenceKey)
    },
    combinedFormValue () {
      if (!this.referenceValueConfig?.referenceKey) return {}
      return {
        ...(this.formValue || {}),
        [this.referenceValueConfig.referenceKey]: this.referenceValue,
      }
    },
    configWithoutReference () {
      return {
        ...(this.config || {}),
        referenceValue: undefined,
      }
    },
    referenceComponent () {
      // Passing question without reference config to prevent infinite loop (FormReferenceValue -> FormReferenceValue -> FormReferenceValue etc)
      // since matchInputTypes returns this component when reference config is present
      return matchInputTypes({ ...this.question, config: this.configWithoutReference }).type
    },
  },
}
</script>
